import React, { useState, useEffect } from 'react';
import { Layout, Menu } from 'antd';
import {
	SolutionOutlined,
	AppstoreOutlined,
	TagOutlined,
	UserOutlined,
	SettingOutlined,
	ScheduleOutlined,
	ShopOutlined,
	ShoppingOutlined,
	UsergroupAddOutlined,
	PoweroffOutlined,
	MedicineBoxOutlined,
	ApartmentOutlined,
	MoneyCollectOutlined
	
} from '@ant-design/icons';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import './NavBar.css';
import { getPharmacyId } from '../Shared';
import { sendData } from '../../httpRequests';

const { Sider } = Layout;
const { SubMenu } = Menu;

export default function NavBar() {
	const location = useLocation();
	const navigate = useNavigate();

	const [pharmacy, setPharmacy] = useState({});
	const [collapsed, setCollapsed] = useState(false);

	useEffect(() => {
		const pharmacyId = getPharmacyId();
		if (pharmacyId) {
			const url = '/pharmacies/getPharmacyById';
			const data = {
				id: pharmacyId
			};
			sendData(url, data).then((response) => {
				const pharmacy = response['pharmacy'];
				setPharmacy(pharmacy);
			});
		}
	}, []);

	const logout = () => {
		localStorage.clear();
		navigate('/login');
	};

	return (
		<Sider style={{ backgroundColor: '#128780' }} collapsible collapsed={collapsed} width={300} className="site-layout-background" onCollapse={(value) => setCollapsed(value)}>
			<div style={{ backgroundColor: '#fff', padding: 16 }}>
				<div className='logo' />
			</div>
			<Menu theme='dark' className='menu' defaultSelectedKeys={[location.pathname]} mode='inline'>
				{(pharmacy.role_id == 2 && (
					<>
						<Menu.Item key='/orders' icon={<SolutionOutlined />}>
							<NavLink to='/orders'>Orders</NavLink>
						</Menu.Item>
						<Menu.Item key='/categories' icon={<AppstoreOutlined />}>
							<NavLink to='/categories'>Categories</NavLink>
						</Menu.Item>
						<Menu.Item key='/admin/ads' icon={<ScheduleOutlined />}>
								<NavLink to='/pharmacy/ads'>Advertisements</NavLink>
							</Menu.Item>
						
						<SubMenu key={'sm1'} icon={<ShoppingOutlined />} title='Products'>
							<Menu.Item key={'/products'} icon={<TagOutlined />}>
								<NavLink to='/products'>Products</NavLink>
							</Menu.Item>
			
							<Menu.Item key={'/newProduct'} icon={<ShopOutlined />}>
								<NavLink to='/newProduct'>Add Product</NavLink>
							</Menu.Item>
						</SubMenu>
						<SubMenu key={'sm2'} icon={<SettingOutlined />} title='Configuration'>
							<Menu.Item key={'/profile'} icon={<UserOutlined />}>
								<NavLink to='/profile'>Profile</NavLink>
							</Menu.Item>
							<Menu.Item key={'/drivers'} icon={<UsergroupAddOutlined />}>
								<NavLink to='/drivers'>Drivers</NavLink>
							</Menu.Item>
							
							{/* <Menu.Item key={'/schedule'} icon={<ScheduleOutlined />}>
						<NavLink to='/schedule'>Schedule</NavLink>
					</Menu.Item> */}
						</SubMenu>
						<Menu.Item key='/payouts' icon={<SolutionOutlined />}>
							<NavLink to='/Billing'>Pays</NavLink>
						</Menu.Item>
					</>
				)) ||
					(pharmacy.role_id == 4 && (
						<>
							<Menu.Item key='/admin/orders' icon={<SolutionOutlined />}>
								<NavLink to='/admin/orders'>Orders</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/pharmacies' icon={<MedicineBoxOutlined />}>
								<NavLink to='/admin/pharmacies'>Pharmacies</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/pharmacyCreateNewProduct' icon={<ShopOutlined />}>
								<NavLink to='/admin/pharmacyCreateNewProduct'>Products</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/ads' icon={<ScheduleOutlined />}>
								<NavLink to='/admin/ads'>Advertisements</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/plans' icon={<MoneyCollectOutlined />}>
								<NavLink to='/admin/plans'>Plans</NavLink>
							</Menu.Item>
							{/* <Menu.Item key='/admin/drivers' icon={<UsergroupAddOutlined />}>
								<NavLink to='/admin/drivers'>Drivers</NavLink>
							</Menu.Item> */}
							<Menu.Item key='/views/Admin/create/Categories' icon={<ApartmentOutlined />}>
								<NavLink to='/views/Admin/create/Categories'>Categories</NavLink>
							</Menu.Item>
						</>
					))
					||(pharmacy.role_id == 5 && (
						<>
							<Menu.Item key='/admin/orders' icon={<SolutionOutlined />}>
								<NavLink to='/admin/orders'>Orders</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/pharmacies' icon={<MedicineBoxOutlined />}>
								<NavLink to='/admin/pharmacies'>Pharmacies</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/pharmacyCreateNewProduct' icon={<ShopOutlined />}>
								<NavLink to='/admin/pharmacyCreateNewProduct'>Products</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/ads' icon={<ScheduleOutlined />}>
								<NavLink to='/admin/ads'>Advertisements</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/plans' icon={<MoneyCollectOutlined />}>
								<NavLink to='/admin/plans'>Plans</NavLink>
							</Menu.Item>
							<Menu.Item key='/admin/drivers' icon={<UsergroupAddOutlined />}>
								<NavLink to='/admin/drivers'>Drivers</NavLink>
							</Menu.Item>
							<Menu.Item key='/views/Admin/create/Categories' icon={<ApartmentOutlined />}>
								<NavLink to='/views/Admin/create/Categories'>Categories</NavLink>
							</Menu.Item>
							<SubMenu key={'#'} icon={<ShoppingOutlined />} title='Pays'>
							<Menu.Item key={'/views/Admin/reportpharmacies'} icon={<TagOutlined />}>
								<NavLink to='/views/Admin/reportpharmacies'>Orders</NavLink>
							</Menu.Item>
							<Menu.Item key={'/views/Admin/reports/ReportDriver'} icon={<TagOutlined />}>
								<NavLink to='/views/Admin/reports/ReportDriver'>Drivers</NavLink>
							</Menu.Item>
						</SubMenu>
						</>
					))
					}
				<Menu.Item key='/logout' icon={<PoweroffOutlined />} onClick={logout}>
					Logout
				</Menu.Item>
			</Menu>
		</Sider>
	);
}
